import type { SearchState } from './index';

type State = { search: SearchState };

export const selectSearchResults = (state: State) => state.search;
